import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function WinterParkProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Winter Park"
      headingExtra="FL"
      introText="Winter Park travelers — Rollins College study-abroad students, Park Avenue professionals, Orange County families, and Central Florida business travelers — have several passport options. Here is how they compare, and why most Winter Park residents choose a registered State Department courier rather than discovering the hard way that Orlando (just 8 miles away) has ZERO passport agencies."
      options={options}
      emergencyDescription="Florida has only 1 passport agency (Miami, ~230 miles via Florida Turnpike, 3.5+ hours) serving 22M+ statewide residents. Winter Park is a cruel paradox — Orlando is literally 8 miles down the road, but Orlando has no passport agency. Rollins College sends hundreds of students abroad every semester — a student discovering an expired passport 48 hours before departure has no viable local option. Orlando hosts 60M+ visitors annually — international tourists staying in Winter Park who discover expired passports mid-vacation face Florida's single agency serving the entire state. Snowbird season (Nov–April) doubles demand across Central Florida. Hurricane evacuation (June–Nov) clogs I-4 and the Florida Turnpike simultaneously — when both routes are gridlocked with evacuees, Miami's single agency is unreachable for days."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing."
    />
  );
}